import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7281cf23"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "backLogin" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    "data-v-5b19dcd8": "",
    src: "/logoHome.png",
    alt: "",
    class: "logoImg"
  })
], -1))
const _hoisted_3 = { class: "card-header" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "注册公司", -1))
const _hoisted_5 = { class: "buttonClass" }
const _hoisted_6 = { class: "bootomCompanymsg" }
const _hoisted_7 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_miezz_button = _resolveComponent("miezz-button")!
  const _component_miezz_select = _resolveComponent("miezz-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_miezz_input = _resolveComponent("miezz-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_miezz_form = _resolveComponent("miezz-form")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_el_card, {
      shadow: "always",
      class: "login",
      style: _normalizeStyle(`height: ${_ctx.height}`)
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_miezz_button, {
            model: _ctx.btnPasswordLogin,
            onHandleClick: _ctx.handleClick
          }, null, 8, ["model", "onHandleClick"]),
          _hoisted_4,
          (_ctx.web?.OpenReg)
            ? (_openBlock(), _createBlock(_component_miezz_button, {
                key: 0,
                model: _ctx.btnRegister,
                onHandleClick: _ctx.handleClick
              }, null, 8, ["model", "onHandleClick"]))
            : _createCommentVNode("", true)
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_miezz_form, {
          ref: "ruleForm",
          modelValue: _ctx.form,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form) = $event))
        }, {
          "form-item": _withCtx(({ item }) => [
            (item.Prop == 'JoinCompanyTypes')
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  prop: item.Prop,
                  label: item.Label
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_miezz_select, {
                      modelValue: _ctx.companyType,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.companyType) = $event)),
                      options: _ctx.companyTypes,
                      prop: "CompanyTypeId",
                      onChange: _ctx.handleCompanyTypeChange
                    }, null, 8, ["modelValue", "options", "onChange"])
                  ]),
                  _: 2
                }, 1032, ["prop", "label"]))
              : _createCommentVNode("", true),
            (
              item.Prop == 'CompanyNameZh' &&
              _ctx.companyTypes?.firstOrDefault((it) => it.Value == _ctx.companyType)
                ?.Data.Code != 'Customer_ForeignTradeIndividual'
            )
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 1,
                  prop: item.Prop,
                  label: item.Label
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_miezz_input, {
                      modelValue: _ctx.form.Data[item.Prop],
                      "onUpdate:modelValue": ($event: any) => ((_ctx.form.Data[item.Prop]) = $event),
                      "fetch-suggestions": _ctx.querySearchNameZh,
                      "trigger-on-focus": false,
                      disabled: item.Disabled,
                      clearable: "",
                      class: "form-item-input-text",
                      "value-key": "NameZh",
                      onHandleSelect: _ctx.handleNameZhSelect
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "fetch-suggestions", "disabled", "onHandleSelect"])
                  ]),
                  _: 2
                }, 1032, ["prop", "label"]))
              : _createCommentVNode("", true),
            (
              item.Prop == 'CompanyNameEnAbbr' &&
              _ctx.form.Data.Type == _ctx.EnumCompanyType.ServiceProvider
            )
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 2,
                  prop: item.Prop,
                  label: item.Label
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_miezz_input, {
                      modelValue: _ctx.form.Data[item.Prop],
                      "onUpdate:modelValue": ($event: any) => ((_ctx.form.Data[item.Prop]) = $event),
                      pattern: "[a-z]",
                      upperCase: true
                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                  ]),
                  _: 2
                }, 1032, ["prop", "label"]))
              : (item.Prop == 'VerifyCode')
                ? (_openBlock(), _createBlock(_component_el_form_item, {
                    key: 3,
                    prop: item.Prop,
                    label: item.Label
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_miezz_input, {
                        class: "sms",
                        modelValue: _ctx.form.Data.VerifyCode,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.Data.VerifyCode) = $event)),
                        placeholder: "请输入验证码",
                        autocomplete: "nope"
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_el_button, {
                        class: "send-sms",
                        type: "primary",
                        disabled: _ctx.countdown != 0,
                        onClick: _ctx.handleSendSMS
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.countdown == 0 ? "验证码" : _ctx.countdown + "秒"), 1)
                        ]),
                        _: 1
                      }, 8, ["disabled", "onClick"])
                    ]),
                    _: 2
                  }, 1032, ["prop", "label"]))
                : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.buttons, (item, i) => {
            return (_openBlock(), _createBlock(_component_miezz_button, {
              style: {"width":"100px"},
              key: i,
              model: item,
              onHandleClick: _ctx.handleClick
            }, null, 8, ["model", "onHandleClick"]))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["style"]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("a", {
        href: _ctx.web?.IcpLink,
        target: "_blank",
        style: {"color":"#828282"}
      }, _toDisplayString(_ctx.web?.Icp), 9, _hoisted_7)
    ])
  ]))
}